export default {
  /**
   * Envía una consulta al chatbot y devuelve la respuesta.
   *
   * @param {Object} context - El contexto de Vue para hacer la petición HTTP
   * @param {Object} request - El objeto con la consulta al chatbot
   * @returns {Promise} - Una promesa que se resuelve con la respuesta del chatbot
   */
  sendQuery (context, request) {
    return new Promise((resolve, reject) => {
      const token = localStorage.getItem('at'); // obtiene el token de acceso almacenado
      const headers = {
        'Authorization': 'Bearer ' + token
      };

      // Crear el objeto de solicitud para el backend
      const apiRequest = {
        message: request.query,
        user_id: context.$store.getters.getUserAccount ? context.$store.getters.getUserAccount.username : 'anonymous',
        password: context.$store.getters.getUserAccount ? context.$store.getters.getUserAccount.password || '' : ''
      };

      context.$http.post('/api/v1/chatbot/query', apiRequest, { headers })
        .then(response => {
          // Procesar la respuesta del API para el formato esperado por el store
          let answers = [];
          let feedbackRequest = false;

          if (response.body && response.body.messages && response.body.messages.length > 0) {
            // Si hay mensajes en la respuesta, devolvemos el array completo
            answers = response.body.messages;
          } else if (response.body && response.body.response) {
            // Si no hay mensajes pero hay una respuesta
            answers = [response.body.response];
          } else {
            // Si no hay respuesta clara
            answers = ['Lo siento, no pude procesar tu consulta. Por favor, intenta de nuevo.'];
          }

          // Verificar si se requiere feedback del usuario
          if (response.body && response.body.feedback_request !== undefined) {
            feedbackRequest = response.body.feedback_request;
          }

          resolve({
            answers: answers,
            feedbackRequest: feedbackRequest
          });
        }, error => {
          // Procesar errores
          let errorMessages = [];

          if (error.body && error.body.messages && error.body.messages.length > 0) {
            errorMessages = error.body.messages;
          } else if (error.body && error.body.message) {
            errorMessages = [error.body.message];
          } else {
            errorMessages = ['Error de conexión. Por favor, intenta de nuevo más tarde.'];
          }

          reject(new Error(errorMessages[0]));
        });
    });
  }
};



// WEBPACK FOOTER //
// ./src/api/chatbot.js